import { render } from "./so-do-cho.vue?vue&type=template&id=47f8a16e&scoped=true"
import script from "./so-do-cho.vue?vue&type=script&lang=js"
export * from "./so-do-cho.vue?vue&type=script&lang=js"

import "./so-do-cho.vue?vue&type=style&index=0&id=47f8a16e&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f8a16e"]])

export default __exports__